import { io } from "socket.io-client";
import { useEffect, useState } from "react";
import { ALCHEMY_RPC_URL, api_url, CRASH_GAME_CONTRACT } from "../../utils/Enviroment";
import { ethers } from "ethers";
import CrashGameABI from "../../utils/CrashGameAbi.json";

const SOCKET_URL = api_url;

const socket = io(SOCKET_URL, {
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: 500,
    reconnectionDelay: 1000,
});

export const useSocketEvents = (events) => {
    useEffect(() => {
        const eventHandlers = [];
        events.forEach(({ eventName, handler }) => {
            socket.on(eventName, handler);
            eventHandlers.push({ eventName, handler });
        });
        return () => {
            eventHandlers.forEach(({ eventName, handler }) => {
                socket.off(eventName, handler);
            });
        };
    }, [socket, events]);
}

export default socket;
